import { clubRatingSummariesSchema } from "../schemas/session-rating";
import { fetchApi } from "./internal";

export const ratings = {
	/**
	 * Rolling feedback per training group the caller may read. The API decides
	 * the scope: owner and admin get every group of the club, a trainer only the
	 * groups they run, anyone else 403.
	 */
	listForClub: (clubId: string) =>
		fetchApi(`/clubs/${clubId}/squads/ratings`, clubRatingSummariesSchema),
};
